import _implicitStylesheets from "./level2FilterOption.css";
import _implicitScopedStylesheets from "./level2FilterOption.scoped.css?scoped=true";
import _adsIcon from "ads/icon";
import _wdsAnalyticsInstrument from "wds/analyticsInstrument";
import _wdsRadioGroup from "wds/radioGroup";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<label class="item_label${0}"${"a0:for"}${2}><span${3}>${"t2"}</span></label>`;
const stc0 = {
  props: {
    "type": "filter"
  },
  key: 0
};
const stc1 = {
  "dash": true
};
const stc2 = {
  slotAssignment: "end",
  props: {
    "ariaHidden": "true",
    "symbol": "chevronup",
    "size": "xsmall",
    "variant": "parent",
    "fill": "#747474"
  },
  key: 6
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, gid: api_scoped_id, b: api_bind, h: api_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, c: api_custom_element} = $api;
  const {_m0, _m1, _m2} = $ctx;
  return [api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, stc0, [api_element("div", {
    className: api_normalize_class_name($cmp.inputType),
    key: 1
  }, [api_element("input", {
    classMap: stc1,
    attrs: {
      "indeterminate": $cmp.isChildSelected,
      "aria-label": $cmp.l2option.label,
      "type": $cmp.inputType,
      "id": api_scoped_id($cmp.l2option.value)
    },
    props: {
      "checked": $cmp.l2option.checked,
      "value": $cmp.l2option.value
    },
    key: 2,
    on: {
      "change": _m0 || ($ctx._m0 = api_bind($cmp.handleParentSelection))
    }
  }), api_static_fragment($fragment1, 4, [api_static_part(0, {
    attrs: {
      "for": api_scoped_id($cmp.l2option.value)
    }
  }, null), api_static_part(2, null, api_dynamic_text($cmp.l2option.label))]), $cmp.l2option.isL2Filter ? api_element("button", {
    className: api_normalize_class_name($cmp.toggleClass),
    attrs: {
      "data-section": $cmp.l2option.label,
      "data-testid": "section-toggle",
      "aria-label": $cmp.toggleLabel,
      "aria-expanded": $cmp.opened
    },
    key: 5,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.handleToggleSectionClick))
    }
  }, [api_custom_element("ads-icon", _adsIcon, stc2)]) : null])]), $cmp.l2option.isL2Filter ? api_element("div", {
    className: api_normalize_class_name($cmp.contentClass),
    key: 7
  }, [api_custom_element("wds-radio-group", _wdsRadioGroup, {
    attrs: {
      "data-testid": $cmp.l2option.label
    },
    props: {
      "id": api_scoped_id($cmp.l2option.label),
      "options": $cmp.l2option.options,
      "multiple": $cmp.l2option.multiple,
      "value": $cmp.selectedValue,
      "focusOnInitialize": $cmp.l2option.shouldFocusFirstElement
    },
    key: 8,
    on: {
      "change": _m2 || ($ctx._m2 = api_bind($cmp.handleChildOptionChange))
    }
  })]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-fn4fr7nc3p";
tmpl.legacyStylesheetToken = "undefined-_level2FilterOption";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
